<div>
	<gb-ui-page-heading [titleText]="pageTitle" bannerType="success">
		<ng-template #subContent>
			<div class="sub-content">
				<p>{{ 'CONFIRMATION.REFERENCE_TEXT' | translate }}</p>
				<p class="h1">
					{{ bookingNumber }}
				</p>
			</div>
		</ng-template>
	</gb-ui-page-heading>
	<div class="govuk-width-container">
		<div class="govuk-grid-row m-0">
			<h1 *ngIf="datastoreService.pageContent.confirmation_page_subtitle" id="main-content" tabindex="-1">
				{{ datastoreService.pageContent.confirmation_page_subtitle }}
			</h1>
			<p [innerHTML]="
					datastoreService.pageContent.confirmation_page_subtitle_body
				"></p>

			@if (agentMode) {
			<button type="button" class="govuk-button govuk-button--inverse heading-button" data-module="govuk-button"
				(click)="datastoreService?.agentRestart()">
				Agent Restart
			</button>
			}

			<ng-template #locationAddress>
				<p>
					@if (selectedLocation.address.address1) {
					{{ selectedLocation.address.address1 }}<br />
					} @if (selectedLocation.address.address2) {
					{{ selectedLocation.address.address2 }}<br />
					} @if (selectedLocation.address.address3) {
					{{ selectedLocation.address.address3 }}<br />
					} @if (selectedLocation.address.address4) {
					{{ selectedLocation.address.address4 }}<br />
					} @if (selectedLocation.address.postcode) {
					{{ selectedLocation.address.postcode }}<br />
					} @if (selectedLocation.address.country) {
					{{ selectedLocation.address.country }} }
				</p>
			</ng-template>

			@if(selectedService.global_id === 48320) {
			<p>
				For your reference, the following confirmation has been sent to the main contact email address you provided.</p>

			<p>Thank you for booking a birth registration appointment on:<br>
				{{
				selectedSlot?.start
				| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
				}}
				at {{ selectedSlot?.displayTime }}
			</p>
			@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
			<p>At: County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
			<p>At: County Hall<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else {
			<p>At: {{ selectedLocation.name }}</p>
			<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
			}

			<h2>Please read the important information below:</h2>
			<p>
				For details of the Registration Office visit
				<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/contact-registrars-and-where-to-find-us/"
					target="_blank">Contact registrars and where to find us - Barnsley Council</a>
				Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your
				appointment, and you will have to rearrange. Thank you for understanding.
			</p>
			<p>No pets are allowed but assistance dogs are welcome.</p>
			<p>We are happy for you to bring your baby to the appointment, but you do not have to.</p>

			<h2>Before attending</h2>
			<p>Please make sure you:</p>
			<ul>
				<li>Have agreed on the child's full name and spellings</li>
				<li>Know the occupation and place of birth (town or city) of baby′s parents</li>
			</ul>

			<h2>Documents to bring</h2>
			<p>Please bring to the appointment either:</p>
			<ul>
				<li>The Notification of Birth that you were given at the hospital</li>
				<li>The Red Book giving us your child's NHS number</li>
			</ul>

			<p>To make sure we record the correct details we recommend that you bring documents which show the parent(s)'
				names, such as:</p>
			<ul>
				<li>Driving licence</li>
				<li>Birth certificate</li>
			</ul>
			<p>You do not have to bring any of these documents to the appointment, but it helps us to avoid any errors.</p>
			<p>
				You will have the chance to check the information recorded before you sign the register page. If you find any
				mistakes after you've signed the register page, you may be charged to correct them.
			</p>

			<h2>Certificates and Payment:</h2>
			<!-- <p>
				If you have paid for any certificates in advance, you can
				collect these at your appointment after the registration has been
				completed.
			</p> -->
			<p>
				<!-- If you are paying for certificates at your appointment, we only accept
				payment from debit/credit cards and smart device contactless payments.
				We do not payments from American Express. Certificates are £12.50
				each. -->
        Certificates cost £12.50 each. You can pay for and receive certificates at 
        your appointment. We only accept debit/credit cards and smart device 
        contactless payments. We do not accept payments from American Express. 
			</p>

			<h2>Cancellations or rearranging your appointment</h2>
			<p>
				If you need to cancel or reschedule before the day of your appointment, please use the unique link in your
				confirmation email.
			</p>
			<!-- <p>We will carry over certificate fees paid in advance if you rearrange your appointment. We will refund any fees
				paid in advance if you cancel the appointment.</p> -->

			<h2>On the day of the appointment</h2>
			<p>
				If you need to cancel or rearrange on the day of your appointment, please contact us on 01226 773555.
			</p>
			<p>We look forward to welcoming you.</p><br>
			} @else if (selectedService.global_id === 48350) {
			<p>
				For your reference, the following confirmation has been sent to the main contact email address you provided.</p>

			<p>Thank you for booking a birth registration declaration appointment on:<br>
				{{
				selectedSlot?.start
				| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
				}}
				at {{ selectedSlot?.displayTime }}
			</p>
			@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
			<p>At: County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
			<p>At: County Hall<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else {
			<p>At: {{ selectedLocation.name }}</p>
			<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
			}

			<h2>Please do read the important information below</h2>
			<p>
				For details of the Registration Office, including a map, visit
				<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/contact-registrars-and-where-to-find-us/"
					target="_blank">Contact registrars and where to find us - Barnsley Council</a>
				Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your
				appointment, and you will have to rearrange. Thank you for understanding.
			</p>
			<p>No pets are allowed but assistance dogs are welcome.</p>
			<p>We are happy for you to bring your baby to the appointment, but you do not have to.</p>

			<h2>Before attending</h2>
			<p>Please make sure you -</p>
			<ul>
				<li>Have agreed on your child′s full name and spellings</li>
				<li>Know the occupation and place of birth (town or city) of baby′s parents</li>
			</ul>

			<h2>Documents to bring</h2>
			<p>Please bring to the appointment either:</p>
			<ul>
				<li>The Notification of Birth that you were given at the hospital</li>
				<li>The Red Book giving us your child's NHS number</li>
			</ul>

			<p>To make sure we record the correct details we recommend that you bring documents which show the parent(s)'
				names, such as:</p>
			<ul>
				<li>Driving licence</li>
				<li>Passport</li>
				<li>Birth certificate</li>
			</ul>
			<p>You do not have to bring any of these documents to the appointment, but it helps us to avoid any errors.</p>
			<p>
				You will have the chance to check the information recorded before you sign the declaration. If you find any
				mistakes after you've signed the declaration, you may be charged to correct them.
			</p>

			<h2>Certificates and Payment</h2>
			<p>After your appointment:</p>
			<ul>
				<li>We will not be able to produce any certificates</li>
				<li>We will email your signed declaration to the register office in the district where the birth took place</li>
				<li>The district where the birth took place will then register the birth</li>
				<li>Certificates are £12.50 each and your payment will need to be made to the register office in the district
					where the birth took place</li>
				<li>You can find the contact details for the register office where the birth took place by visiting <a
						href="https://www.gov.uk/register-offices" target="_blank" rel="noopener noreferrer">Find a register office
						- GOV.UK<span class="govuk-visually-hidden"> (opens in new tab)</span></a></li>
			</ul>

			<h2>Cancellations or rearranging your appointment</h2>
			<p>
				If you need to cancel or reschedule before the day of your appointment, please use the unique link in your
				confirmation email.
			</p>

      <p>
        The link lets you change the time or date of your appointment within the same office. If you wish to rearrange your appointment to a different office location, please contact us on 01226 773555. Any pre-paid certificates will transfer to your new booking.
      </p>

      <p>
       If you wish to cancel your appointment and have pre-paid for any certificates, please contact us on 01226 773555 for a refund. 
      </p>
      
			<h2>On the day of the appointment</h2>
			<p>
				If you need to cancel or rearrange on the day of your appointment, please contact us on 01226 773555.
			</p>
			<p>
				If you have an appointment on a Saturday which you need to cancel or rearrange on the day, please call
				the register office on 01226 773555.
			</p>
			<p>We look forward to welcoming you.</p><br>
			} @else if (selectedService.global_id === 48335) {
			<p>
				For your reference, the following confirmation has been sent to the
				email address you provided. We can confirm that you have booked an
				appointment to register a death at the {{ selectedLocation.name }} on
				{{
				selectedSlot?.start
				| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
				}}
				at {{ selectedSlot?.displayTime }}
			</p>
			@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
			<p>At: County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
			<p>At: County Hall<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else {
			<p>At: {{ selectedLocation.name }}</p>
			<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
			}
			<p>
				To view details of the Registration Office, including maps, please go to
				<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/contact-registrars-and-where-to-find-us/"
					target="_blank">Contact registrars and where to find us - Barnsley Council</a>
				Please ensure you arrive on time for your scheduled appointment; regretfully,
				late arrival may mean you cannot be seen and your appointment will need
				to be rearranged. No pets are allowed but assistance dogs are very
				welcome.
			</p>

			<h2>Please note these important points below</h2>

			<h2>Documents required:</h2>
			<p>
				The registration cannot be completed without the necessary medical
				paperwork from the Medical Examiner's Office or Coroner. If this
				paperwork is not received, we will contact you to reschedule your
				appointment.
			</p>
			<p>
				The information you provide the registrar must be true and accurate to
				the best of your knowledge. To help prevent errors we recommend that you
				bring any available documents that show the deceased's details. Examples
				of these documents may be: a passport, driving licence, birth
				certificate, deed poll or change of name deed document, marriage/civil
				partnership certificate, council tax bill or recent utility bill
			</p>
			<p>
				Please note that it is not mandatory to bring these documents to the
				appointment.
			</p>
			<p>
				If you'd like to see a full list of the information you'll need to
				provide please <a
					href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/deaths-and-funerals/register-a-death/"
					target="_blank" rel="noopener noreferrer">click here<span class="govuk-visually-hidden"> (opens in new
						tab)</span></a>
			</p>
			<p>
				We would also recommend that the person registering the death brings a
				document to show their name and address (such as a driving licence).
				This is to again help with the accuracy of the registration.
			</p>
			<p>
				You will have the opportunity to check the information recorded before
				you sign the register page. If any mistakes are found after you've
				signed the register page, there may be a charge to correct them.
			</p>

			<h2>Documents Issued:</h2>
			<p>
				During the appointment, the registrar will complete the required
				paperwork for the funeral directors and, if you are able to provide
				their details, will forward it to them directly.
			</p>
			<p>
				The registrar will also assist you in setting up the free Tell Us Once
				service (<a href="https://www.gov.uk/after-a-death/organisations-you-need-to-contact-and-tell-us-once">What to
					do after someone dies</a>), should you wish to use it.
				During the appointment, you will be given a unique reference number,
				which you can later use to access the service online or by telephone.
				The registrar will explain more about Tell Us Once at the appointment.
			</p>

			<h2>Certificates & Payment:</h2>
			<!-- <p>
				If you have paid for any certificates in advance you will be able to
				collect these at your appointment after the registration has been
				completed.
			</p> -->
			<p>
				<!-- If you are paying for certificates at your appointment, we only accept
				payment from debit/credit cards and smart device contactless payments.
				We cannot accept payments from American Express. Certificates are £12.50
				each. -->
        Certificates cost £12.50 each. You can pay for and receive certificates at your 
        appointment. We only accept debit/credit cards and smart device contactless 
        payments. We do not accept payments from American Express. 
			</p>

			<h2>Cancellations/Rescheduling:</h2>
      <p>
        The link lets you change the time or date of your appointment within the same office. If you wish to rearrange your appointment to a different office location, please contact us on 01226 773555. Any pre-paid certificates will transfer to your new booking.
      </p>
			<p>
				If on the day of your appointment you are unable to attend due to being
				unwell or for any other reason, please contact us on 01226 773555.
			</p>
			<p>
				If you need to cancel an appointment on a Saturday, please call
				the register office on 01226 773555.
			</p>
			} @else if (selectedService.global_id === 48400) {
			<p>
	For your reference, the following confirmation has been sent to the main contact email address you provided.
</p>

<p>
	This confirms that you have booked an appointment to give notice of marriage or civil partnership on:<br>
	{{
	selectedSlot?.start
	| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
	}}
	at {{ selectedSlot?.displayTime }}
</p>
@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
<p>At: County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
<p>At: County Hall<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else {
<p>At: {{ selectedLocation.name }}</p>
<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
}

<h2>Please read the important information below</h2>
<p>
	For details of the Registration Office, including a map, please visit
	<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/contact-registrars-and-where-to-find-us/"
		target="_blank">Contact registrars and where to find us - Barnsley Council<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>
<p>
	Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your
	appointment, and you will have to rearrange. Thank you for understanding.
</p>
<p>No pets are allowed but assistance dogs are very welcome.</p>

<p>
	Your Notice is venue-specific. You will need to know the full name and address of your ceremony venue before
	your notice appointment.
</p>

<p>
	Giving notice is not the same as booking the venue. If you have not booked the venue, or registrars to attend
	your ceremony, please do so.
</p>

<h2>Documents to bring</h2>
<p>
	You and your partner must bring certain original documents (not photocopies) to your notice appointment, as
	required by law.
</p>
<p>
	If you don't bring the right documents, we won't be able to take your notice, so please take the time to check
	what you need and gather everything in advance.
</p>
<p>
	<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/give-notice-of-marriage-or-civil-partnership/"
		target="_blank" rel="noopener noreferrer">Check what documents to bring when giving notice<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>

<h2>Payment</h2>
<p>
	The standard notice fee is £46.50 per person, you will need to pay at your appointment.
</p>
<p>Additional fees may apply in certain circumstances:</p>
<ul>
	<li>
		<strong>Home Office Referral:</strong> If either of you needs to be referred to the Home Office, there is an
		additional fee of £16.50 each, which you will pay at your appointment which you attend together. If this
		applies to you, or if you or your partner have marriage visas, you will both need to bring printed
		passport-sized photographs. To find out if you will be subject to a Home Office referral, or you need passport
		photos, please visit
		<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/give-notice-of-marriage-or-civil-partnership/"
			target="_blank" rel="noopener noreferrer">Give notice of marriage or civil partnership - Barnsley
			Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>.
	</li>
	<li>
		<strong>Foreign Divorce Documents:</strong> If either of you was divorced outside the British Isles, you'll
		need to pay a non-refundable fee for checking the foreign divorce paperwork. The fee is charged per divorce
		rather than per couple. The fees are:
		<ul>
			<li>£55 if the documents can be checked locally</li>
			<li>£83 if the documents need to be referred to the General Register Office (GRO)</li>
			<li>
				You can find more details about what documents to bring and how much you may need to pay by visiting
				<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/give-notice-of-marriage-or-civil-partnership/"
					target="_blank" rel="noopener noreferrer">Give notice of marriage or civil partnership - Barnsley
					Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>
			</li>
		</ul>
	</li>
</ul>
<p>
	Any additional fees will be taken at your appointment. We only accept debit/credit cards and smart device
	contactless payments. We do not accept payments from American Express.
</p>

<h2>Cancelling or rearranging your appointment</h2>
<h3>Before the day of the appointment</h3>
<p>
	If you need to cancel or rearrange before the day of your appointment, please use the unique link in your
	confirmation email.
</p>
      <p>
        The link lets you change the time or date of your appointment within the same office. If you wish to rearrange your appointment to a different office location, please contact us on 01226 773555. Any pre-paid certificates will transfer to your new booking.
      </p>

<h3>On the day of the appointment</h3>
<p>
	If you need to cancel or rearrange on the day of your appointment, please contact us on 01226 773555.
</p>
<p>
	If you have a Saturday appointment which you need to cancel on the day, please call
	the register office on 01226 773555.
</p>
<p>Kind regards</p>
			} @else if (selectedService.global_id === 48400) {
			<p>
	For your reference, the following confirmation has been sent to the main contact email address you provided.
</p>

<p>
	This confirms that you have booked an appointment to give notice of marriage or civil partnership on:<br>
	{{
	selectedSlot?.start
	| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
	}}
	at {{ selectedSlot?.displayTime }}
</p>
@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
<p>At: County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
<p>At: County Hall<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else {
<p>At: {{ selectedLocation.name }}</p>
<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
}

<h2>Please read the important information below</h2>
<p>
	For details of the Registration Office, including a map, please visit
	<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/contact-registrars-and-where-to-find-us/"
		target="_blank">Contact registrars and where to find us - Barnsley Council<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>
<p>
	Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your
	appointment, and you will have to rearrange. Thank you for understanding.
</p>
<p>No pets are allowed but assistance dogs are very welcome.</p>

<p>
	Your Notice is venue-specific. You will need to know the full name and address of your ceremony venue before
	your notice appointment.
</p>

<p>
	Giving notice is not the same as booking the venue. If you have not booked the venue, or registrars to attend
	your ceremony, please do so.
</p>

<h2>Documents to bring</h2>
<p>
	You and your partner must bring certain original documents (not photocopies) to your notice appointment, as
	required by law.
</p>
<p>
	If you don't bring the right documents, we won't be able to take your notice, so please take the time to check
	what you need and gather everything in advance.
</p>
<p>
	<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/give-notice-of-marriage-or-civil-partnership/"
		target="_blank" rel="noopener noreferrer">Check what documents to bring when giving notice<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>

<h2>Payment</h2>
<p>
	The standard notice fee is £46.50 per person, you will need to pay at your appointment.
</p>
<p>Additional fees may apply in certain circumstances:</p>
<ul>
	<li>
		<strong>Home Office Referral:</strong> If either of you needs to be referred to the Home Office, there is an
		additional fee of £16.50 each, which you will pay at your appointment which you attend together. If this
		applies to you, or if you or your partner have marriage visas, you will both need to bring printed
		passport-sized photographs. To find out if you will be subject to a Home Office referral, or you need passport
		photos, please visit
		<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/give-notice-of-marriage-or-civil-partnership/"
			target="_blank" rel="noopener noreferrer">Give notice of marriage or civil partnership - Barnsley
			Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>.
	</li>
	<li>
		<strong>Foreign Divorce Documents:</strong> If either of you was divorced outside the British Isles, you'll
		need to pay a non-refundable fee for checking the foreign divorce paperwork. The fee is charged per divorce
		rather than per couple. The fees are:
		<ul>
			<li>£55 if the documents can be checked locally</li>
			<li>£83 if the documents need to be referred to the General Register Office (GRO)</li>
			<li>
				You can find more details about what documents to bring and how much you may need to pay by visiting
				<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/give-notice-of-marriage-or-civil-partnership/"
					target="_blank" rel="noopener noreferrer">Give notice of marriage or civil partnership - Barnsley
					Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>
			</li>
		</ul>
	</li>
</ul>
<p>
	Any additional fees will be taken at your appointment. We only accept debit/credit cards and smart device
	contactless payments. We do not accept payments from American Express.
</p>

<h2>Cancelling or rearranging your appointment</h2>
<h3>Before the day of the appointment</h3>
<p>
	If you need to cancel or rearrange before the day of your appointment, please use the unique link in your
	confirmation email.
</p>

<p>
  The link lets you change the time or date of your appointment within the same office. If you wish to rearrange your appointment to a different office location, please contact us on 01226 773555. Any pre-paid certificates will transfer to your new booking.
</p>

<h3>On the day of the appointment</h3>
<p>
	If you need to cancel or rearrange on the day of your appointment, please contact us on 01226 773555.
</p>
<p>
	If you have a Saturday appointment which you need to cancel on the day, please call
	the register office on 01226 773555.
</p>
<p>Kind regards</p>
			}
      @else if (selectedService.global_id === 48365) {
			<p>
				For your reference, the following confirmation has been sent to the
				email address you provided. We can confirm that you have booked an
				appointment to register a death by declaration at the
				{{ selectedLocation.name }} on
				{{
				selectedSlot?.start
				| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
				}}
				at {{ selectedSlot?.displayTime }}
			</p>
			@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
			<p>At: County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
			<p>At: County Hall<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else {
				<p>At: {{ selectedLocation.name }}</p>
			<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
			}
			<p>
				To view details of the Registration Office, including maps, please go to
				<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/contact-registrars-and-where-to-find-us/"
					target="_blank">Contact registrars and where to find us - Barnsley Council</a>
				Please ensure you arrive on time for your scheduled appointment; regretfully,
				late arrival may mean you cannot be seen and your appointment will need
				to be rearranged. No pets are allowed but assistance dogs are very
				welcome.
			</p>

			<h2>Please note these important points below</h2>

			<h2>Documents required:</h2>
			<p>
				You must contact the register office in the district where the death
				occurred to ensure that they have received the Medical Certificate of
				Cause of Death (MCCD) or paperwork from the Coroner's Office if
				applicable. A copy of this will need to be provided to the register office
				(call 01226 773555 for details) for us to be able to take the
				declaration from you. If this paperwork is not received, we will contact
				you to reschedule your appointment.
			</p>
			<p>
				You can find the contact details for the register office where the death
				took place by visiting Find a register office - Welcome to GOV.UK (opens
				new page Find a register office)
			</p>
			<p>
				The information you provide the registrar must be true and accurate to
				the best of your knowledge. To help prevent errors we recommend that you
				bring any available documents that show the deceased's details. Examples
				of these documents may be: a passport, driving licence, birth
				certificate, deed poll or change of name deed document, marriage/civil
				partnership certificate, council tax bill or recent utility bill
			</p>
			<p>
				Please note that it is not mandatory to bring these documents to the
				appointment.
			</p>
			<p>
				If you'd like to see a full list of the information you'll need to
				provide please <a
					href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/deaths-and-funerals/register-a-death/"
					target="_blank" rel="noopener noreferrer">click here<span class="govuk-visually-hidden"> (opens in new
						tab)</span></a>
			</p>
			<p>
				We would also recommend that the person registering the death by
				declaration brings a document to show their name and address (such as a
				driving licence). This is to again help with the accuracy of the
				registration.
			</p>
			<p>
				You will have the opportunity to check the information recorded before
				you sign the declaration. If any mistakes are found after you've signed
				the declaration, there may be a charge to correct them.
			</p>

			<h2>Documents & certificates produced by the registering district:</h2>
			<p>After your appointment with us -</p>
			<ul>
				<li>
					We will, as soon as possible the same day, email your signed
					declaration to the register office in the district where the death
					took place
				</li>
				<li>They will then register the death</li>
				<li>
					They will be the ones to produce any death certificates and paperwork
					for the funeral director
				</li>
				<li>
					Certificates are £12.50 each and your payment will need to be made to
					the register office in the district where the death took place
				</li>
			</ul>

			<h2>Documents Issued:</h2>
			<p>
				The registrar will also assist you in setting up the free Tell Us Once
				service (<a href="https://www.gov.uk/after-a-death/organisations-you-need-to-contact-and-tell-us-once">What to
					do after someone dies</a>), should you wish to use it.
				During the appointment, you will be given a unique reference number,
				which you can later use to access the service online or by telephone.
				The registrar will explain more about Tell Us Once at the appointment.
			</p>

			<h2>Cancellations/Rescheduling:</h2>
<p>
	If you need to cancel or rearrange before the day of your appointment, please use the unique link in your
	confirmation email.
</p>

<p>
  The link lets you change the time or date of your appointment within the same office. If you wish to rearrange your appointment to a different office location, please contact us on 01226 773555. Any pre-paid certificates will transfer to your new booking.
</p>
			<p>
				If on the day of your appointment you are unable to attend due to being
				unwell or for any other reason, please contact us on 01226 773555.
			</p>
			<p>
				If you need to cancel an appointment on a Saturday, please call
				the register office on 01226 773555.
			</p>
			} @else if (selectedService.global_id === 48415) {
						<p>
	For your reference, the following confirmation has been sent to the main contact email address you provided.
</p>

<p>
	This confirms that you have booked an appointment to give notice of marriage or civil partnership on:<br>
	{{
	selectedSlot?.start
	| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
	}}
	at {{ selectedSlot?.displayTime }}
</p>
@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
<p>At: County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
<p>At: County Hall<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else {
<p>At: {{ selectedLocation.name }}</p>
<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
}

<h2>Please read the important information below</h2>
<p>
	For details of the Registration Office, including a map, please visit
	<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/contact-registrars-and-where-to-find-us/"
		target="_blank">Contact registrars and where to find us - Barnsley Council<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>
<p>
	Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your
	appointment, and you will have to rearrange. Thank you for understanding.
</p>
<p>No pets are allowed but assistance dogs are very welcome.</p>

<p>
	Your Notice is venue-specific. You will need to know the full name and address of your ceremony venue before
	your notice appointment.
</p>

<p>
	Giving notice is not the same as booking the venue. If you have not booked the venue, or registrars to attend
	your ceremony, please do so.
</p>

<h2>Documents to bring</h2>
<p>
	You and your partner must bring certain original documents (not photocopies) to your notice appointment, as
	required by law.
</p>
<p>
	If you don't bring the right documents, we won't be able to take your notice, so please take the time to check
	what you need and gather everything in advance.
</p>
<p>
	<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/give-notice-of-marriage-or-civil-partnership/"
		target="_blank" rel="noopener noreferrer">Check what documents to bring when giving notice<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>

<h2>Payment</h2>
<p>
	The standard notice fee is £46.50 per person, you will need to pay at your appointment.
</p>
<p>Additional fees may apply in certain circumstances:</p>
<ul>
	<li>
		<strong>Home Office Referral:</strong> If either of you needs to be referred to the Home Office, there is an
		additional fee of £16.50 each, which you will pay at your appointment which you attend together. If this
		applies to you, or if you or your partner have marriage visas, you will both need to bring printed
		passport-sized photographs. To find out if you will be subject to a Home Office referral, or you need passport
		photos, please visit
		<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/give-notice-of-marriage-or-civil-partnership/"
			target="_blank" rel="noopener noreferrer">Give notice of marriage or civil partnership - Barnsley
			Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>.
	</li>
	<li>
		<strong>Foreign Divorce Documents:</strong> If either of you was divorced outside the British Isles, you'll
		need to pay a non-refundable fee for checking the foreign divorce paperwork. The fee is charged per divorce
		rather than per couple. The fees are:
		<ul>
			<li>£55 if the documents can be checked locally</li>
			<li>£83 if the documents need to be referred to the General Register Office (GRO)</li>
			<li>
				You can find more details about what documents to bring and how much you may need to pay by visiting
				<a href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/give-notice-of-marriage-or-civil-partnership/"
					target="_blank" rel="noopener noreferrer">Give notice of marriage or civil partnership - Barnsley
					Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>
			</li>
		</ul>
	</li>
</ul>
<p>
	Any additional fees will be taken at your appointment. We only accept debit/credit cards and smart device
	contactless payments. We do not accept payments from American Express.
</p>

<h2>Cancelling or rearranging your appointment</h2>
<h3>Before the day of the appointment</h3>
<p>
	If you need to cancel or rearrange before the day of your appointment, please use the unique link in your
	confirmation email.
</p>

<p>
  The link lets you change the time or date of your appointment within the same office. If you wish to rearrange your appointment to a different office location, please contact us on 01226 773555. Any pre-paid certificates will transfer to your new booking.
</p>

<h3>On the day of the appointment</h3>
<p>
	If you need to cancel or rearrange on the day of your appointment, please contact us on 01226 773555.
</p>
<p>
	If you have a Saturday appointment which you need to cancel on the day, please call
	the register office on 01226 773555.
</p>
<p>Kind regards</p>
			} @else {
			<div class="govuk-grid-row">
				<div class="govuk-grid-column-full">
					<div class="govuk-summary-card">
						<div class="govuk-summary-card__title-wrapper">
							<h2 class="govuk-summary-card__title">
								{{ 'COMMON.BOOKING' | translate }}
							</h2>
						</div>

						<div class="govuk-summary-card__content">
							<dl class="govuk-summary-list">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.SERVICE' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedService?.name }}
									</dd>
								</div>
								<div class="govuk-summary-list__row" *ngIf="selectedResourceObj?.name">
									<dt class="govuk-summary-list__key">Venue</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedResourceObj?.name }}
									</dd>
								</div>
							</dl>
						</div>
					</div>

					<div class="govuk-summary-card">
						<div class="govuk-summary-card__title-wrapper">
							<h2 class="govuk-summary-card__title">
								{{ 'COMMON.DATE_TIME' | translate }}
							</h2>
						</div>
						<div class="govuk-summary-card__content">
							<dl class="govuk-summary-list">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.DATE' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{
										selectedSlot?.start
										| date
										: 'EEEE d MMMM yyyy'
										: ''
										: translateService.currentLang
										}}
									</dd>
								</div>

								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.TIME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedSlot?.displayTime }}
									</dd>
								</div>

								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.DURATION' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ booking.duration }} minutes
									</dd>
								</div>
							</dl>
						</div>
					</div>

					<div class="govuk-summary-card">
						<div class="govuk-summary-card__title-wrapper">
							<h2 class="govuk-summary-card__title">
								{{ 'COMMON.PATIENT_DETAILS' | translate }}
							</h2>
						</div>
						<div class="govuk-summary-card__content">
							<dl class="govuk-summary-list">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.NAME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ client?.first_name }} {{ client?.last_name }}
									</dd>
								</div>

								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.EMAIL_ADDRESS' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ datastoreService?.booking?.email }}
									</dd>
								</div>

								<div class="govuk-summary-list__row" *ngIf="client?.mobile_number">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.MOBILE_NUMBER' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedSlot?.mobile_number }}
									</dd>
								</div>

								<div class="govuk-summary-list__row" *ngIf="client?.postcode">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.POSTNAME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedSlot?.postcode }}
									</dd>
								</div>
							</dl>
						</div>
					</div>
				</div>
			</div>

			<div class="govuk-grid-row pb-4">
				<div class="govuk-grid-column-full">
					<ng-container *ngIf="!isAdminJourney">
						<button type="submit" class="btn btn-primary" (click)="restartJourney()">
							{{ 'CONFIRMATION.RETURN_HOME' | translate }}
						</button>
					</ng-container>
					<ng-container *ngIf="isAdminJourney">
						<p class="govuk-body">
							For agents, please refresh the browser tab to return to the start.
							<br />
							For registration team, please close the browser tab and return to
							the back-office.
						</p>
					</ng-container>
				</div>
			</div>
			}
		</div>
	</div>
</div>
